import React from 'react';
import { connect } from 'react-redux';

import ListPage from '@/src/shared/components/ListPage';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';

const Bulletin = () => {
  const [loading, results] = useListSearch({
    pubCode: 828,
  });

  return <ListPage title="CompliAssist Bulletins" results={results} loading={loading} />;
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(Bulletin, COMPLIANCE_ACCESS.COMPLIANCE_RESOURCES)
);
